var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pop"},[_c('el-tooltip',{attrs:{"placement":"top-start","trigger":"hover","content":_vm.content,"close-delay":0,"width":"20px"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }